import { Button, Card, Popover, Row, Space, Tooltip } from "antd";
import Meta from "antd/es/card/Meta";
import { useEffect, useState } from "react";
import i18next from "i18next";
import Icon from '@ant-design/icons';
import { UserService } from "../../../service/userService";
import noImage from "../../../assets/images/no_image.png"

import { ReactComponent as pencil } from '../../../assets/images/esri/pencil-32.svg'
import EditMapConfigComponent from "./management/EditMapConfigComponent";
import { useSelector } from "react-redux";
import { user_state } from "../../../features/user/userSlice";


const MapListComponent = ({ setMapConfig }) => {

    const userstate = useSelector(user_state);

    const [userContent, setUserContent] = useState({})
    const [editMapConfig, setEditMapConfig] = useState(null)
    const [user, setUser] = useState()

    

    let mapConfIds = [];

    const getUserContent = () => {
        //TODO recuperar si hay usuario loggeado, y el contenido asociado al mismo
        UserService.getUser()
            .then((data) => {
                //console.log("data", data);
                mapConfIds = [];
                setUserContent(data)
            })
            .catch(err => {
                //console.log(err.response)
                err.response.json().then(res => {
                    //console.log(res);
                });
            })
    }

   
    useEffect(() => {
        getUserContent();
        setUser(userstate.username)
    }, [])

    if(user != userstate.username){
        getUserContent();
        setUser(userstate.username)
    }

    let sgvMapListComponentStyle = {
        top: "20px",
        right: "20px",
        left: "20px",
        zIndex: 1
    }

    function rerender(){
        getUserContent();
    }

    return (
        <>
            {editMapConfig == null && <Space direction="vertical" style={sgvMapListComponentStyle}>
                <Space wrap>
                    {userContent.roleList && userContent.roleList.map((role, i) => {
                        return role.roleMapList && role.roleMapList.map((mapConfig, i) => {
                            return !mapConfIds.includes(mapConfig.sgvmapRoleMapcnfPK.idMapConf) && mapConfIds.push(mapConfig.sgvmapRoleMapcnfPK.idMapConf)
                                && <MapListItemComponent mapConfig={mapConfig}
                                    setMapConfig={setMapConfig} setEditMapConfig={setEditMapConfig}></MapListItemComponent>
                        })
                    })}
                </Space>
            </Space>}
            {editMapConfig != null && <EditMapConfigComponent editMapConfig={editMapConfig} setEditMapConfig={setEditMapConfig} callback={rerender}></EditMapConfigComponent>}
        </>
    )
}
export default MapListComponent;


const MapListItemComponent = ({ mapConfig, setMapConfig, setEditMapConfig }) => {
    return (
        <Popover content={mapConfig.map.description} title={mapConfig.map.name}>
            <Card
                onClick={(e) => setMapConfig(mapConfig)}
                hoverable
                style={{ width: 150 }}
                extra={<Tooltip title={i18next.t('common.tools.edit.name')}><Button size='small' onClick={(e) => { setEditMapConfig(mapConfig); e.stopPropagation();; }}
                    type="secondary" shape="circle"> <Icon component={pencil} />
                </Button></Tooltip>}
                cover={mapConfig.map.thumbnailB64str ?
                    <Row justify="center" style={{ display: "flex" }}><img alt={mapConfig.map.name}
                        src={mapConfig.map.thumbnailB64str} style={{
                            width: "auto",
                            maxWidth: "150px",
                            height: "100px"
                        }} /></Row> :
                    <Row justify="center" style={{ display: "flex" }}><img alt={mapConfig.map.name} src={noImage} style={{
                        width: "auto",
                        maxWidth: "150px",
                        height: "100px"
                    }} /></Row>}>
                <Meta title={mapConfig.map.name} description={mapConfig.map.description} />
            </Card>
        </Popover>)
}
